// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-color{position:relative;display:block}.input-color__picker{position:absolute;top:0;right:-10px;transform:translateX(100%);z-index:2}", ""]);
// Exports
module.exports = exports;
